import type { CuratedCopy } from "./preview-copy.types";
export const paintbotPwCopy: CuratedCopy = {
  blurb:
    "Sixteen painted cogs, two teams, ten hearts. Hold the ground around a heart for three seconds to claim it, keep it to keep scoring, and take the rest of the island from the other team.",
  beats: () => [
    {
      title: "Claim hearts",
      body: "Stay within range of a heart for three seconds to claim it. If both teams are in range, capture pauses; if the attackers leave, it resets.",
    },
    {
      title: "Hold to score",
      body: "The owner keeps earning points until someone else completes a capture. Holding all ten hearts raises your income but does not end the match.",
    },
    {
      title: "Stay alive",
      body: "A cog that falls respawns near one of your hearts after a short wait, so fights over a heart never end the game on their own.",
    },
  ],
};
